
import { Auth } from 'aws-amplify'
class Profile {
	constructor(request) {
		this.request = request
		this.endpoint = 'profile'
	}

	async GetProfile(username, mode = "", payload = {}) {
		/*
		 * Possible values for mode: 'basic' | 'info' | 'organization' | 'organizationlist'| 'coupon
		 */

		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		const body = {
			username:username,
			mode:mode,
			...payload
		}

		// Store user's exclusive list to localstorage to avoid multiple API calls
		if (mode === "exclusivelist") {
			/*
			 * If exclusive list is already stored in the localstorage, return it instead
			 * Otherwise, make an API call to fetch exclusive list, then store to localstorage
			 */
			const promise = new Promise((resolve, reject) => {
				if (localStorage.getItem("userExclusiveList") !== null) {
					resolve(JSON.parse(localStorage.getItem("userExclusiveList")));
				} else {
					this.request.send(
						`${this.endpoint}/get`,
						'POST',
						body,
						jwtToken
					).then((data) => {
						if (data.status === "OK") {
							localStorage.setItem("userExclusiveList", JSON.stringify(data));
						}

						resolve(data)
					}).catch ((err)=> {
						reject(err);
					})
				}
			})

			return promise;
		}
		return this.request.send(
			`${this.endpoint}/get`,
			'POST',
			body,
			jwtToken
		)
	}

	async EditProfile(username, mode = "" , payload) {
		/*
		 * Possible values for mode: 'organization'
		 */
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		const body = {
			username:username,
			mode, 
			...payload
		}

		return this.request.send(
			`${this.endpoint}/update`,
			'POST',
			body,
			jwtToken
		)
	}

	async AddProfile(username, mode = "", payload = {}) {
		/*
		 * Possible values for mode: 'organization'
		 */

		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		const body = {
			username, 
			mode,
			...payload
		}

		return this.request.send(
			`${this.endpoint}/add`,
			'POST',
			body,
			jwtToken
		)
	}

	async DeleteProfile(username, mode = "", payload = {}) {
		/*
		 * Possible values for mode: 'organization'
		 */

		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		const body = {
			username, 
			mode,
			...payload
		}

		return this.request.send(
			`${this.endpoint}/delete`,
			'POST',
			body,
			jwtToken
		)
	}
}


export default Profile